import React, { MouseEvent } from 'react';
import {
  ChevronDownIcon, PencilIcon, TrashIcon, XMarkIcon,
} from '@heroicons/react/20/solid';
import Button from '../../../../../elements/Button';
import { useAppDispatch } from '../../../../../app/hooks';
import { IFocus } from '../focus-types';
import { resetCreateFocusForm, setDeleteFocusModalData } from '../focusModuleSlice';

interface FocusViewHeaderProps {
  focusViewInEditMode: boolean,
  setFocusViewInEditMode: (flag: boolean) => void,
  focus: IFocus,
  inEditMode: boolean,
  open: boolean, // disclosureIsOpen
}

export default function FocusViewHeader(props: FocusViewHeaderProps) {

  const {
    open,
    inEditMode,
    focus,
    setFocusViewInEditMode,
    focusViewInEditMode,
  } = props;

  const dispatch = useAppDispatch();

  const displayName = focus.focusCategoryName;

  const onDelete = (e: MouseEvent) => {
    e.stopPropagation();

    dispatch(setDeleteFocusModalData({
      focus,
      showModal: true,
    }));
  };

  const onEdit = (e: MouseEvent) => {
    if (open) { //  - allow open/close of a tab
      e.stopPropagation();
    }

    setFocusViewInEditMode(true);
  };

  const onCancelEdit = (e: MouseEvent) => {
    if (! open) { //  - allow open/close of a tab
      e.stopPropagation();
    }

    setFocusViewInEditMode(false);

    dispatch(resetCreateFocusForm(focus.coreFocusCategoryId)); // or id??
  };

  return (
    <>
      <div className="flex flex-col px-4 py-4 items-start">
        <span className="text-xs text-neutral-700">
          Focus:
          {' '}
          {focus.parentFocusCategoriesNames}
        </span>
        <span className="font-semibold text-base text-neutral-800">
          {displayName}
        </span>
      </div>
      <div className="flex flex-row items-center">
        {
          inEditMode && (
            <div className="mr-2.5 flex flex-row">
              <Button
                onClick={onDelete}
                size="small"
                inverted
                redText
                roundedFull
                // disabled
                iconLeft={<TrashIcon className="w-4 h-4 mr-2" />}
                description="Delete"
              />
              <div className="ml-2">
                {
                  focusViewInEditMode ? (
                    <Button
                      onClick={onCancelEdit}
                      size="small"
                      inverted
                      roundedFull
                      // disabled
                      iconLeft={<XMarkIcon className="w-4 h-4 mr-2" />}
                      description="Cancel"
                    />
                  ) : (
                    <Button
                      onClick={onEdit}
                      size="small"
                      inverted
                      roundedFull
                      // disabled
                      iconLeft={<PencilIcon className="w-4 h-4 mr-2" />}
                      description="Edit"
                    />
                  )
                }
              </div>
            </div>
          )
        }
        <ChevronDownIcon
          className={`${open ? 'transform rotate-180' : ''} w-4 h-4 mr-5 text-main-400`}
        />
      </div>
    </>
  );
}
